import { baseCrudFactory } from "~/stores/base.crud.store.ts"
import { Api } from "~/api/Api.ts"
import { useInterventionStore } from "~/stores"
import { groupById, mapById } from "~/helpers"
import { InterventionPlanningModel } from "~/model/intervention_planning.model"
import type { InterventionPlanningResource } from "~/api"

export const useInterventionPlanningStore = baseCrudFactory({
    endpoint: "interventions",
    primaryKey: "IDINTERVENTION_PLANNING",
    title: "intervention planning",
    startDateKey: "RDV_DEBUT",
    endDateKey: "RDV_FIN",
    model: InterventionPlanningModel,
    modules: {
        intervention: () => useInterventionStore(),
    },
    state: {
        idPersonnelImpersonate: null as number | null,
    },
    getters: {
        groupPlanningByIntervention() {
            return groupById(this.items, "IDINTERVENTION")
        },
        eventsFormated() {
            return this.itemsByDate.map((item) => ({
                id: item.IDINTERVENTION_PLANNING || item.IDINTERVENTION,
                title: item.INTERVENTION?.LIBELLE || "Intervention",
                start: item.RDV_DEBUT,
                end: item.RDV_FIN,
                data: item,
                typeEvent: "intervention_planning",
                color: "black",
            }))
        },
    },
})
